export enum StatusEnum {
  /** 待处理 */
  PENDING = 0,
  /** 处理中 */
  PROCESSING = 1,
  /** 处理失败 */
  ALL_FAILURE = 2,
  /** 部分失败 */
  PARTIAL_FAILURE = 3,
  /** 成功 */
  SUCCESS = 4,
  /** 已重试 */
  RETRY = 5,
}

export function taskIsPending(taskStatus: number) {
  return [StatusEnum.PENDING, StatusEnum.PROCESSING].includes(taskStatus)
}

export function taskIsFail(taskStatus: number) {
  return [StatusEnum.ALL_FAILURE, StatusEnum.PARTIAL_FAILURE].includes(taskStatus)
}

export function taskIsPartialFail(taskStatus: number) {
  return [StatusEnum.PARTIAL_FAILURE].includes(taskStatus)
}

export function taskIsAllFail(taskStatus: number) {
  return [StatusEnum.ALL_FAILURE].includes(taskStatus)
}

export function taskIsSuccess(taskStatus: number) {
  return [StatusEnum.SUCCESS].includes(taskStatus)
}
